<div class="row row5">
    <div class="col-md-9 featured-box-detail sports-wrapper m-b-10">

        <div class="game-heading mb-2">
            <span class="card-header-title">
                Multi Market
            </span>
        </div>

        <div *ngIf="data">

            <div class="" *ngFor="let dt of data;let di=index;trackBy:trackByIndex;">

                <div class="game-heading multi-game-heading" (click)="detailPage(dt[0])">
                    <span class="card-header-title">
                        {{dt[0]?.event?.name ? dt[0]?.event?.name : dt[0]?.name}}
                    </span>
                    <span class="float-right">
                        <a href="javascript:void(0)" class="UserChipData">
                            <i class="fa fa-angle-double-right"></i>
                        </a>
                    </span>
                </div>

                <div class="market" *ngFor="let item of dt;let j=index;trackBy:trackByIndex">

                    <!-- MATCH_ODDS AND BOOKMAKER -->
                    <div class="markets">

                        <!-- MATCH_ODDS -->
                        <div class="main-market" *ngIf="item?.market_id[0] && item?.market_id[0] == '1'">
                            <app-market-detail [data]="{marketData: item, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-market-detail>
                        </div>
                        <!-- /MATCH_ODDS -->

                        <!-- BOOKMAKER -->
                        <div class="row row5 bookmaker-market mt-1" *ngIf="item?.market_id[0] && item?.market_id[0] == '8'">
                            <div class="bm1 col-xl-12">
                                <app-bookmaker-detail [data]="{marketData: oddsLisDis[item?.market_id], odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-bookmaker-detail>
                            </div>
                        </div>
                        <!-- /BOOKMAKER -->

                    </div>
                    <!-- /MATCH_ODDS AND BOOKMAKER -->

                    <!--  FANCY -->
                    <div class="fancy-market row row5" *ngIf="item?.market_id[0] && item?.market_id[0] == '9'">
                        <div class="col-12">
                            <div>
                                <div class="market-title mt-1">
                                    Fancy
                                    <a href="javascript:void(0)" (click)="openModalWithComponent('f')"  class="m-r-5 game-rules-icon"><span><i class="fa fa-info-circle float-right"></i></span></a>
                                </div>
                                <app-fancy-detail [data]="{fancyData: item?.data, tabVal:item?.allFancy, isFancy:true, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>
                            </div>
                        </div>
                    </div>
                    <!-- /FANCY -->
                
                </div>

            </div>

        </div>
        
        <div *ngIf="data?.length == 0">
            <div class="market">
                <h4 class="text-center p-5">There are currently no followed multi markets, please add some markets from events.</h4>
            </div>
        </div>

        <app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>
    </div>
    <div id="sidebar-right" class="col-md-3 sidebar-right">
        <div class="ps">
            <div class="sidebar-right-inner">
                <div class="card m-b-10 place-bet">
                    <div class="card-header">
                        <h6 class="card-title d-inline-block">Place Bet</h6>
                    </div>
                    <div>
                        <app-d-bet-slip [data]="betSlipData" [exposLisDis]="exposLisDis" (closeBet)="closeBet($event)"
                            (updateData)="updateData($event)" (changeExpo)="changeExpo($event)"></app-d-bet-slip>
                    </div>
                </div>
                <div class="card m-b-10 my-bet">
                    <div class="card-header">
                        <h6 class="card-title d-inline-block">My Bet</h6>
                    </div>
                    <div class="card-body">
                        <app-d-bet-list *ngIf="isLogin()"></app-d-bet-list>
                    </div>
                </div>
            </div>
            <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
                <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
            </div>
            <div class="ps__rail-y" style="top: 0px; right: 0px;">
                <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
            </div>
        </div>
    </div>
</div>